document.addEventListener('DOMContentLoaded', function() {
    var searchContainer = document.querySelector('.search-container');
    var quickLinks = document.querySelector('.quick-links.right-side');
    var closeIcon = document.querySelector('.search-container .close-icon');
    var searchInput = document.querySelector('#searchbar__searchBox__input');
    var searchLink = document.querySelector('#search-link');
    // Search Container Expansion Function
    if(searchInput){
        document.querySelector('#searchbar__searchBox__input').addEventListener('click', function() {
            // Add class if not there and open search / hide links , otherwise do nothing
            if (searchContainer.className.indexOf('open') === -1) {
                _classList(searchContainer,'open', 'add');
                _classList(quickLinks,'d-none', 'add');
            }
        });
    }

    if(searchLink){
        document.querySelector('#search-link').addEventListener('click', function() {
            // Remove overlay
            searchContainer.classList.toggle('open');
        });
    }

    //Close icon
    if( closeIcon ){
        closeIcon.addEventListener('click', function() {
            searchContainer.classList.remove('open');
        });
    }

    var _classList = function(el, className, action){
        if (el.classList) {
            switch(action){
                case 'add':
                    el.classList.add(className);
                    break;
                case 'remove':
                    el.classList.remove(className);
                    break;
                default:
                    el.classList.add(className);
                    break;
            }
        } else {
            switch(action){
                case 'add':
                    el.className += ' ' + className;
                    break;
                case 'remove':
                    var classNames = el.className.split(' ');
                    var index = classNames.indexOf(className);
                    if (index !== -1) {
                        classNames.splice(index, 1);
                        el.className = classNames.join(' ');
                    }
                    break;
                default:
                    el.className += ' ' + className;
                    break;
            }
        }
    }
});